<template>
  <mf-toolbar :logo="toolbarLogo" :logo-click-action="goToHome">
    <span class="client-name">{{ $getLoggedUser().client }}</span>
    <logged-user-menu class="logged-user-menu" />
    <template v-slot:extension> </template>
  </mf-toolbar>
</template>

<script>
import LoggedUserMenu from '@/components/LoggedUserMenu.vue'

export default {
  components: {
    LoggedUserMenu,
  },
  computed: {
    toolbarLogo() {
      return this.$getWhitelabelLogo()
    },
  },
  methods: {
    goToHome() {
      this.$router.push('/home').catch(() => {})
    },
  },
}
</script>

<style lang="scss">
.client-name {
  text-transform: uppercase;
  margin-right: 18px;
}
</style>
